"use client";

import dynamic from "next/dynamic";
const styles = new Proxy({"MeshViewer":"MeshViewer-c090f","canvasContainer":"canvasContainer-c090f","canvas":"canvas-c090f","loading":"loading-c090f","spinner":"spinner-c090f","error":"error-c090f"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });

const MeshViewerClient = dynamic(() => import("./MeshViewerClient"), {
  ssr: false,
  loading: () => (
    <div className={styles.loading}>
      <div className={styles.spinner} />
    </div>
  ),
});

export default MeshViewerClient;
